import FilesControls from './FilesControls'

export default FilesControls
